export enum CourseSectionType {
  PART = 'PART',
  CHAPTER = 'CHAPTER',
  UNIT = 'UNIT',
  ACTIVITY = 'ACTIVITY',
}
